import { jsx as t, Fragment as a } from "@emotion/react/jsx-runtime";
import { Cover as p, Illustration as u, CoverCategoryEnum as m, IllustrationCategoryEnum as n } from "@partoohub/iconography";
import { Stack as y } from "../../Stack/index.js";
const s = (i, r, l) => typeof i == "object" && i !== null && l.every((e) => e in i) && Object.values(r).includes(i.type), v = ({
  dataTrackId: i,
  headerContent: r
}) => {
  const l = (o) => s(o, m, ["type", "name"]), e = (o) => s(o, n, ["type", "name"]);
  return r ? /* @__PURE__ */ t(a, { children: l(r) ? /* @__PURE__ */ t(p, { cover: r }) : e(r) ? /* @__PURE__ */ t(y, { style: {
    paddingTop: "24px"
  }, children: /* @__PURE__ */ t(u, { dataTrackId: `illustration__dialog__${i}`, illustration: r, width: "320", height: "140" }) }) : r }) : /* @__PURE__ */ t("div", { style: {
    paddingTop: "8px"
  } });
};
export {
  v as DialogHeader,
  s as isElementOfType
};
